import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ArticlePageComponent } from './article-page/article-page.component';
import { ContributorPageComponent } from './contributor-page/contributor-page.component';
import { ContributorListPageComponent } from './contributor-list-page/contributor-list-page.component';
import { AllArticlesPageComponent } from './all-articles-page/all-articles-page.component';

const blogRoutes: Routes = [
  {path: "contributor/:author", redirectTo: "author/:author"},
  {path: "contributors", redirectTo: "authors"},
  {path: "author/:author", component: ContributorPageComponent},
  {path: "authors", component: ContributorListPageComponent},
  // {path: "preview/:slug", component: ArticlePageComponent},
  {path: "preview/:slug", component: ArticlePageComponent},
  {path: ":aid/:slug", redirectTo: "/news/:slug"},
  {path: ":slug", component: ArticlePageComponent},
  {path: "", component: AllArticlesPageComponent},
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  }

]

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(blogRoutes)
  ],
})
export class BlogRoutingModule { }
